import React from "react";
import "../../InvoiceModal.css";
import { useTranslation } from "react-i18next";

const ShipmentSummary = ({ data }) => {
  const { t } = useTranslation("finances");
  return (
    <>
      <div className="invmodal__shipment_summary">
        {/* <div className="invmodal__shipment_summaryhding">Shipment summary</div> */}
        <div className="invmodal__shipment_summarycntnt">
          <div className="invmodal__shipment_summaryfrom">
            <div className="invmodal__shipment_sumitemhding">
              {t("invoice.summary.shipFrom")}
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.reference")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.f_reference ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.name")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.fattension ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.company")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.fcompany ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.address")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.faddress ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.country")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.fcountry ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.state")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.fstate ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.city")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.fcity ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.zip")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.fzip ?? "-"}
              </div>
            </div>

            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.phone")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.fphone ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.email")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.femail ?? "-"}
              </div>
            </div>
          </div>
          <div className="invmodal__shipment_summaryto">
            <div className="invmodal__shipment_sumitemhding">
              {t("invoice.summary.shipTo")}
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.reference")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.referance_code ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.name")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.tattension ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.company")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.tcompany ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.address")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.taddress ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.country")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.tcountry ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.state")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.tstate ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.city")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.tcity ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.zip")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.tzip ?? "-"}
              </div>
            </div>

            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.phone")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.tphone ?? "-"}
              </div>
            </div>
            <div className="invmodal__shipment_sumitem">
              <div className="invmodal__shipment_sumitemleft">
                {t("invoice.summary.email")}
              </div>
              <div className="invmodal__shipment_sumitemright">
                {data?.temail ?? "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="invmodal__shipment_details">
        <div className="invmodal__shipment_detailshding">
          {t("invoice.summary.additionalServices")}
        </div>
        <table className="invmodal__shdetails_table">
          <thead>
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.summary.signature")}
            </th>
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.summary.residentialDelivery")}
            </th>
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.summary.insurance")}
            </th>
            {data?.insurance && data?.insurance_type === "Shipment" && (
              <>
                <th className="invmodal__shdetails_tablehd">
                  {t("invoice.summary.insuranceType")}
                </th>
                <th className="invmodal__shdetails_tablehd">
                  {t("invoice.summary.insuranceAmount")}
                </th>
              </>
            )}
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.summary.tailgatePickup")}
            </th>
            <th className="invmodal__shdetails_tablehd">
              {t("invoice.summary.tailgateDelivery")}
            </th>
          </thead>
          <tbody>
            <tr>
              <td className="invmodal__shdetails_tableitem">
                {data?.signature
                  ? t("invoice.summary.enabled")
                  : t("invoice.summary.disabled")}
              </td>
              <td className="invmodal__shdetails_tableitem">
                {data?.tresidential
                  ? t("invoice.summary.enabled")
                  : t("invoice.summary.disabled")}
              </td>
              <td className="invmodal__shdetails_tableitem">
                {data?.insurance
                  ? t("invoice.summary.enabled")
                  : t("invoice.summary.disabled")}
              </td>
              {data?.insurance && data?.insurance_type === "Shipment" && (
                <>
                  <td className="invmodal__shdetails_tableitem">
                    {t("invoice.summary.perShipment")}
                  </td>
                  <td className="invmodal__shdetails_tableitem">
                    {data?.insurance_amount ?? "0"}
                  </td>
                </>
              )}
              <td className="invmodal__shdetails_tableitem">
                {data?.tailgate_pickup
                  ? t("invoice.summary.enabled")
                  : t("invoice.summary.disabled")}
              </td>
              <td className="invmodal__shdetails_tableitem">
                {data?.tailgate_delivery
                  ? t("invoice.summary.enabled")
                  : t("invoice.summary.disabled")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ShipmentSummary;
